export const CLOTHING_SIZE_FILTER = 'v_clothingsize_uFilter';
export const SIZE_FILTER = 'v_tcpsize_uFilter';
export const PRICE_FILTER = 'unbxd_price_range_uFilter';
export const COLOR_FILTER = 'TCPColor_uFilter';
export const FIT_FILTER = 'v_tcpfit_unbxd_uFilter';
export const MIN_OFFER_PRICE = 'min_offer_price';
